export default __webpack_public_path__ + "slices/main/assets/public/media/amanda_slack_rec.41e7ada8e8e2449033bd7bda2d3f4c0f.png";